import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSessionStats } from '../contexts/SessionStatsContext';
import { useSessionNavigation } from '../utils/navigation';
import './SubjectQuestions.css';
import homeIcon from '../assets/images/icons/home.svg';
import arrowRightIcon from '../assets/images/icons/arrow-right.svg';
import biologyIcon from '../assets/images/icons/biologia.svg';
import chemistryIcon from '../assets/images/icons/chimica.svg';
import physicsIcon from '../assets/images/icons/fisica.svg';
import tripleDotsIcon from '../assets/images/icons/tripledots.svg';
import nextIconsrc from '../assets/images/icons/next.svg';


const TripleDotsIcons = ({ width = 30, height = 38, style = {} }) => (
  <img 
    src={tripleDotsIcon} 
    alt="Fill in the blank" 
    width={width} 
    height={height} 
    style={style}
  />
);

const NextIcon = ({ width = 32, height = 32, style = {} }) => ( <img 
    src={nextIconsrc} 
    alt="Next" 
    width={width} 
    height={height} 
    style={style}
  />
);

// Map subject IDs to names and icons
const subjectConfig = {
  'biologia': {
    name: 'Biologia',
    icon: biologyIcon
  },
  'chimica-propedeutica-biochimica': {
    name: 'Chimica e propedeutica biochimica',
    icon: chemistryIcon
  },
  'chimica': {
    name: 'Chimica',
    icon: chemistryIcon
  },
  'fisica': {
    name: 'Fisica',
    icon: physicsIcon
  }
};

function SubjectQuestions() {
  const { subjectId } = useParams();
  const navigate = useNavigate();
  const { questionStatistics, loading, error } = useSessionStats();
  const { getHomeUrl, getQuestionUrl } = useSessionNavigation();

  const getPercentageColor = (percentage) => {
    if (percentage >= 70) return 'var(--success-color)';
    if (percentage >= 50) return 'var(--warning-color)';
    return 'var(--error-color)';
  };

  const handleBackClick = () => {
    navigate(getHomeUrl());
  };

  const handleQuestionClick = (questionNumber) => {
    navigate(getQuestionUrl(subjectId, questionNumber));
  };

  if (loading) {
    return null; // Skeleton is shown by AdminLayout
  }

  if (error) {
    return (
      <div className="subject-questions">
        <div className="error-message">
          <p>Errore nel caricamento delle domande: {error.message}</p>
        </div>
      </div>
    );
  }

  const subjectInfo = subjectConfig[subjectId];
  if (!subjectInfo) {
    return (
      <div className="subject-questions">
        <div className="error-message">
          <p>Materia non trovata</p>
        </div>
      </div>
    );
  }

  // Filter questions for this subject
  const subjectQuestions = questionStatistics.filter(
    question => question.subject_name === subjectInfo.name
  );

  if (subjectQuestions.length === 0) {
    return (
      <div className="subject-questions">
        <div className="subject-header">
          <button className="subject-back-button" onClick={handleBackClick}>
            <img src={homeIcon} alt="Home" />
          </button>
          
          <div className="subject-title">
            <img src={arrowRightIcon} alt="Arrow" className="breadcrumb-separator" />
            <span className="subject-title-text">
              Domande di <img src={subjectInfo.icon} alt={subjectInfo.name} className="subject-icon-inline" /> <span className="subject-name">{subjectInfo.name}</span>
            </span>
          </div>
        </div>
        <div className="error-message">
          <p>Nessuna domanda trovata per questa materia</p>
        </div>
      </div>
    );
  }

  return (
    <div className="subject-questions">
      <div className="subject-header">
        <button className="subject-back-button" onClick={handleBackClick}>
          <img src={homeIcon} alt="Home" />
        </button>
        
        <div className="subject-title">
          <img src={arrowRightIcon} alt="Arrow" className="breadcrumb-separator" />
          <span className="subject-title-text">
            Domande di <img src={subjectInfo.icon} alt={subjectInfo.name} className="subject-icon-inline" /> <span className="subject-name">{subjectInfo.name}</span>
          </span>
        </div>
      </div>

      <div className="questions-list">
        {subjectQuestions.map((question, index) => (
          <div 
            key={question.question_number} 
            className="question-item"
            onClick={() => handleQuestionClick(question.question_number)}
          >
            <div className="question-content-wrapper">
              <div className="question-left">
                <span className="question-number">Domanda {question.question_number + 1}</span>
                <h2 className='question-text'>
                  {question.question_text.split(/\[:blank:\]/).map((part, index, array) => (
                    <React.Fragment key={index}>
                      {part}
                      {index < array.length - 1 && (
                        <span className="fill-blank" data-blank={index + 1} style={{
                          marginLeft: '10px', marginRight: '10px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          verticalAlign: 'top'
                        }}>
                          <TripleDotsIcons width={30} height={38} style={{
                            verticalAlign: 'top',
                            display: 'inline-block',
                            transform: 'translateY(-2px)'
                          }} />
                        </span>
                      )}
                    </React.Fragment>
                  ))}
                </h2>
              </div>
              
              <div className="question-divider"></div>
              
              <div className="question-stats">
                <span 
                  className="correct-percentage"
                  style={{ color: getPercentageColor(question.accuracy) }}
                >
                  {question.accuracy.toFixed(2)}%
                </span>
                <span className="stats-label">risposte corrette</span>
              </div>
                <NextIcon style={{ marginRight: '24px' }} />


            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SubjectQuestions;